import { useContext } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { axiosClient } from '../../../library/Service/axiosClient';

const useDashboard = () => {
    const { state, dispatch } = useContext(SmartContext);

    const getDashboardData = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/header-data`);
        setStateValue('dashboardData.dashboardCounts', response?.data?.data || {});
    };

    const getApplicationsOverTime = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/applications-over-time`);
        setStateValue('dashboardData.applicationsOverTime', response?.data?.data);
    };

    const getJobTypeDistributionData = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/job-type-distribution`);
        setStateValue('dashboardData.jobTypeDistribution', response?.data?.data);
    };

    const getJobByLocation = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/job-by-location`);
        setStateValue('dashboardData.jobByLocation', response?.data?.data);
    };

    const getExperienceLevelDistribution = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/experience-level-distribution`);
        setStateValue('dashboardData.experienceLevelDistribution', response?.data?.data);
    };

    const getAverageSalaryRangeByExperience = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/average-salary-range-by-experience`);
        setStateValue('dashboardData.averageSalaryRangeByExperience', response?.data?.data);
    };

    const getTopHiringCompanies = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/top-hiring-companies`);
        setStateValue('dashboardData.topHiringCompanies', response?.data?.data);
    };

    const getEngagementMetrics = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/engagement-metrics`);
        setStateValue('dashboardData.engagementMetrics', response?.data?.data);
    };

    const getHotJobs = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/hot-jobs`);
        setStateValue('dashboardData.hotJobs', response?.data?.data);
    };

    const getTrendingJobs = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/trending-jobs`);
        setStateValue('dashboardData.trendingJobs', response?.data?.data);
    };

    const getRecentActivitySummary = async () => {
        let response: any;
        response = await axiosClient().post(`${process.env.REACT_APP_JOB_SERVER}/dashboard/recent-activity-summary`);
        setStateValue('dashboardData.recentActivitySummary', response?.data?.data);
    };

    const setStateValue = (dataKey: string, value: string) =>
        dispatch({ type: 'CONTROL_VALUE_CHANGE', payload: { dataKey, value, errorMessages: [] } });


    return {
        setStateValue,
        getDashboardData,
        getApplicationsOverTime,
        getJobTypeDistributionData,
        getJobByLocation,
        getExperienceLevelDistribution,
        getAverageSalaryRangeByExperience,
        getTopHiringCompanies,
        getEngagementMetrics,
        getHotJobs,
        getTrendingJobs,
        getRecentActivitySummary
    };
};

export default useDashboard;
